import {
  ChangeDetectorRef,
  Component,
  ElementRef,
  HostBinding,
  Inject,
  Input,
  NgZone,
  OnDestroy,
  OnInit,
  ViewChild
} from '@angular/core';
import {
  Future,
  Instrument
} from '@iv/model/instrument';
import { OptionMonitorService } from '../../option-monitor.service';
import {
  forkJoin,
  interval
} from 'rxjs';
import { OptionMonitorTableComponent } from '../option-monitor-table/option-monitor-table.component';
import { OptionMonitorFiltersComponent } from '../filters/option-monitor-filters.component';
import { AppState } from '@iv/store/app.reducer';
import { AppStore } from '@iv/store/app.store';
import * as Redux from 'redux';
import { getCurrentTab } from '@iv/store/tabs/tabs.selectors';
import * as TabsActions from '@iv/store/tabs/tabs.actions';
import Utils, { getHttpParams } from '@iv/shared/utils';
import { CommonService } from 'app/core/services/common.service';
import { getColumnsEntities } from '@iv/store/columns/columns.selectors';
import * as ColumnsActions from '@iv/store/columns/columns.actions';
import { WorkspaceService } from 'app/workspace/workspace.service';
import { getAllInstruments } from '@iv/store/instruments/instrument.reducer';
import { NgxSpinnerService } from 'ngx-spinner';
import { OptionsCalculatorComponent } from 'app/calculators/options-calculator/options-calculator.component';
import { ProbabilityCalculatorComponent } from 'app/calculators/probability-calculator/probability-calculator.component';
import { ColorThemeService } from 'app/common/services/color-theme.service';
import { ThemeColor } from 'app/common/enums/theme-color.enum';
import { Destroyer } from 'app/common/utils';
import {
  finalize,
  takeUntil
} from 'rxjs/operators';
import { getPermissions } from '@iv/store/permissions/permissions.reducer';
import { PermissionTypes } from '@iv/store/permissions/permissions.models';
import {
  TabComponent,
  TabTypeEnum
} from '@iv/model/tabs.model';
import { getAllFutures } from '@iv/store/futures/futures.reducer';
import { FuturesCalculatorComponent } from 'app/calculators/futures-calculator/futures-calculator.component';
import {PaymentWindowService} from '../../../payment-window.service';

export class Tile {
  date: string;
  iv: number;
  iv_eod: number;
  dateR: string;
}

@Component({
  selector: 'iv-live-option-monitor',
  templateUrl: './option-monitor.component.html',
  styleUrls: ['./option-monitor.component.scss']
})
export class OptionMonitorComponent extends Destroyer implements OnInit, OnDestroy, TabComponent {

  popupCredit = false;
  isError = false;

  constructor(
    private service: CommonService,
    private zone: NgZone,
    private optionMonitorService: OptionMonitorService,
    private workspaceService: WorkspaceService,
    private commonService: CommonService,
    @Inject(AppStore) private store: Redux.Store<AppState>,
    private spinner: NgxSpinnerService,
    private ref: ChangeDetectorRef, private _eref: ElementRef,
    private readonly colorThemeService: ColorThemeService,

    private readonly paymentWindowService: PaymentWindowService
  ) {
    super();
    this.unsubscribeStore = store.subscribe(() => this.updateState());
    this.updateState();
  }

  get selectedExpiration(): any {
    return this._selectedExpiration || {
      id: 'ALL',
      value: 'All',
      type: 'type'
    };
  }

  set selectedExpiration(value: any) {
    this._selectedExpiration = value;
  }

  get selectedStrike(): any {
    return this._selectedStrike || '5';
  }

  set selectedStrike(value: any) {
    this._selectedStrike = value;
  }

  get selectedType(): any {
    return this._selectedType || {name: 'Call&Put', value: ''};
  }

  set selectedType(value: any) {
    if (this._selectedType === undefined || this._selectedType.value !== value.value) {
      this._selectedType = value;
    }
  }

  get selectedCenter(): number {
    return this._selectedCenter || 0;
  }

  set selectedCenter(value: number) {
    this._selectedCenter = value;
  }

  get instruments(): Instrument[] {
    return this._instruments;
  }

  @Input() set instruments(value: Instrument[]) {
    this._instruments = value;
  }

  @Input() HV;
  @Input() IVX;
  @Input() stockInfo;
  @Input() hasOptions;
  @Input() hideCharts;
  @ViewChild('serviceResult', {static: false}) serviceResult !: ElementRef;
  @ViewChild(OptionMonitorTableComponent, {static: false}) dataGrid !: OptionMonitorTableComponent;
  @ViewChild(OptionMonitorFiltersComponent, {static: false}) filter !: OptionMonitorFiltersComponent;
  @ViewChild(FuturesCalculatorComponent, {static: false}) futuresCalculator !: FuturesCalculatorComponent;
  @ViewChild(OptionsCalculatorComponent, {static: false}) optionsCalculator !: OptionsCalculatorComponent;
  @ViewChild(ProbabilityCalculatorComponent, {static: false}) probabilityCalculator !: ProbabilityCalculatorComponent;
  @HostBinding('class') class = 'service';

  public volatilityTablePopupVisible: boolean = false;
  public showIvx: boolean = true;
  public themeColor: ThemeColor;
  public themeColorEnum = ThemeColor;
  public tabType: string;
  public tabTypeEnum = TabTypeEnum;
  public currentTab = getCurrentTab(this.store.getState());
  public isFutures = this.currentTab.type.includes('future');
  public id = this.currentTab.type === TabTypeEnum.OPTION_CHAIN ? this.currentTab.data.instrument.stockId : this.currentTab.data.future.underlyingId;
  public futExpDate: string;

  boxWidth = 0;
  sliderExps = [];
  tiles: Tile[] = [];
  actTiles: Tile[] = [];
  leftButt = false;
  rightButt = false;
  mode = getPermissions(this.store.getState()).find(permission => {
    if (this.currentTab.type === TabTypeEnum.OPTION_CHAIN) {
      return permission === PermissionTypes.DELAYED_STOCKS || permission === PermissionTypes.RT_STOCKS;
    } else {
      return permission === PermissionTypes.EOD_FUTURES || permission === PermissionTypes.RT_FUTURES;
    }
  });
  isDelayed = this.currentTab.type === TabTypeEnum.OPTION_CHAIN ? this.mode === PermissionTypes.DELAYED_STOCKS : this.mode === PermissionTypes.EOD_FUTURES;
  isRt = this.currentTab.type === TabTypeEnum.OPTION_CHAIN ? this.mode === PermissionTypes.RT_STOCKS : this.mode === PermissionTypes.RT_FUTURES;
  selectedInstrument: any = {};
  calculatorsPopupPopupVisible = false;
  isEODOptions = false;
  isEODProbability = false;
  regionIdOptions;
  regionIdProbability;
  instrument: Future;
  result: any[];
  expiration = null; // expiration to download csv
  expirations: any[] = [];
  types: any[] = [{name: 'Call&Put', value: ''}, {name: 'Call', value: 'CALL'}, {name: 'Put', value: 'PUT'}];
  defaultColumns: any[] = [];
  visibleColumns: string[] = [];
  settingColumns: any[] = [];
  gridColumns: any[] = [];
  gridVisibleColumns: any[] = [];
  strikeSkewChartVisible = false;
  timeSkewChartVisible = false;
  downloadCSVPopupVisible = false;
  chartVisible = false;
  chartFutCurveVisible = false;
  surfaceVisible = false;
  isLoading: boolean;
  editColumnsPopupVisible = false;
  editColumnsPopupPosition: any = {my: 'right top', at: 'bottom', of: '#editServiceColumnsButton'};
  editColumnsPopupHeight = 370;
  isMac = !!navigator.platform.match(/(Mac|iPhone|iPod|iPad)/i);
  isMobile = Utils.isMobile();
  editColumnsClass = (this.isMac
    ? 'edit-columns-popup option-monitor-columns-popup mac'
    : 'edit-columns-popup option-monitor-columns-popup') + (this.isMobile ? ' mobile' : '');
  downloadSCVClass = (this.isMac
    ? 'delete-popup download-csv mac'
    : 'delete-popup download-csv') + (this.isMobile ? ' mobile' : '');
  scrollBuffer = 100;
  chartExpiration: any = null;
  chartStrike: any = null;
  isLoadResult = false;
  alwaysVisibleColumns = [
    this.currentTab.type === TabTypeEnum.OPTION_CHAIN ? 'expirationdate' : 'optexpdate',
    'forwardprice',
    'forwardprice_eod',
    'days',
    'days_eod',
    'iv',
    'iv_eod'
  ];
  settingTip: string;
  downloadSCVPopupPosition = {my: 'right top', at: 'bottom', of: '#downloadService'};
  private _tabId: any;
  private unsubscribeStore;
  private offset = 0;
  private qtt = 0;
  private _selectedExpiration: any;
  private _selectedStrike: any;
  private _selectedType: any;
  private _selectedCenter: any;
  private _instruments: Instrument[] = [];
  private gridHeaderTitles: string[] = [];

  private static getSortedData(result: any[]) {
    return result.sort((a, b) => {
      return a.strike - b.strike;
    });
  }

  private static _getEodColumns() {
    return [
      'strike',
      'bid_eod',
      'ask_eod',
      'volume_eod',
      'ivint_eod',
      'delta_eod',
      'vega_eod'
    ];
  }

  private static getMon(month: number): string {
    switch (month) {
      case 0:
        return 'Jan';
      case 1:
        return 'Feb';
      case 2:
        return 'Mar';
      case 3:
        return 'Apr';
      case 4:
        return 'May';
      case 5:
        return 'Jun';
      case 6:
        return 'Jul';
      case 7:
        return 'Aug';
      case 8:
        return 'Sep';
      case 9:
        return 'Oct';
      case 10:
        return 'Nov';
      case 11:
        return 'Dec';
    }
  }

  ngOnInit(): void {
    this.mode.toLowerCase();
    this.themeColor = this.colorThemeService.getColorTheme();
    this.getOptionMonitorColumns();
    this.loadExpirations();
    this.futExpDate = this.currentTab.data.serviceTabs[0].filters.futExpDate;
    this.showIvx = !!(this.hasOptions);

    // TODO: Нужно загружать монитор только после того, как мы загрузим колонки, все возможные экспирации, фильтры из сторы.

    interval(30 * 1000)
      .pipe(takeUntil(this.destroy$))
      .subscribe(() => {
        this.getResult(true, false, () => {
          this.gridVisibleColumns = this.getGridVisibleColumns();
        });
      });

    this.paymentWindowService.showPaymentWindow();
  }

  ngOnDestroy(): void {
    if (typeof this.unsubscribeStore === 'function') {
      this.unsubscribeStore();
    }

    super.ngOnDestroy();
  }

  updateState() {
    const state = this.store.getState();
    const currentTab = getCurrentTab(state);
    const columnsConfig = getColumnsEntities(state)[currentTab.type === TabTypeEnum.OPTION_CHAIN ? 'OptionsMonitor' : 'FuturesOptionMonitor'];
    const currentFutExpDate = this.currentTab.data.serviceTabs[0].filters.futExpDate;
    if (currentTab && currentTab.data.serviceTabs) {
      this._tabId = currentTab.id;
      this.tabType = currentTab.type;
      this.instrument = currentTab.type === TabTypeEnum.OPTION_CHAIN ||
        currentTab.type === TabTypeEnum.STOCK_MONITOR
          ? currentTab.data.instrument
          : currentTab.data.future;
      this.selectedExpiration = currentTab.data.serviceTabs[0].filters.expirations;
      this.selectedStrike = currentTab.data.serviceTabs[0].filters.strikesN;
      this.selectedCenter = currentTab.data.serviceTabs[0].filters.center;
      this.selectedType = currentTab.data.serviceTabs[0].filters.type;
      this.visibleColumns = currentTab.data.serviceTabs[0].visibleColumns;
    }
    this.defaultColumns = columnsConfig;
    this.instruments = this.currentTab.type === TabTypeEnum.OPTION_CHAIN ||
      currentTab.type === TabTypeEnum.STOCK_MONITOR ? getAllInstruments(state) : getAllFutures(state);

    if (this.futExpDate !== currentFutExpDate) {
      this.futExpDate = currentFutExpDate;
      sessionStorage.setItem('expirationDate', this.futExpDate);
      this.expirations = [];
      this.result = [];
      this.getExpirations(this.currentTab.type);
      this._getListOptionsDataRow();
    }
  }

  private loadExpirations(): void {
    if (this.currentTab.type === TabTypeEnum.OPTION_CHAIN) {
      this.getSliderExpirations();

      if (this.instrument.regionId === 1) {
        this.getExpirationsRt();
        return;
      }
      this.getExpirations(this.currentTab.type);
    }
  }

  private getOptionMonitorColumns(): void {
    this.optionMonitorService.getColumns(this.currentTab.type)
      .subscribe(columns => {
        if (!this.defaultColumns) {
          this._updateDefaultConfig(columns.visibleColumns.map(x => x));
        }

        if (!this.visibleColumns && this.instrument.regionId === 1) {
          this._updateServiceTabData('visibleColumns', this.defaultColumns);
        }

        if (this.instrument.regionId !== 1) {
          this._updateServiceTabData('visibleColumns', OptionMonitorComponent._getEodColumns());
        }

        this.settingColumns = Object.values(columns.settingColumns).map(x => Object.assign({}, x));
        this.gridColumns = Object.assign({}, columns.gridColumns);
        this.gridVisibleColumns = this.getGridVisibleColumns();
        const chart = <HTMLElement>document.getElementsByClassName('ivx30-chart')[0];
        this.scrollBuffer = (chart ? chart.clientHeight : 0) + 100;
      });
  }

  private getExpirationsRt(): void {
    this.optionMonitorService.getExpirationRt(this.instrument.stockId)
      .then(expirations => {
        expirations.forEach((item) => {
          this.expirations.push({
            id: item.expDate,
            value: item.expDate,
            type: 'expiration',
            typeId: item.type,
          });
        }, this);

        this.getResult(true, true, () => {
          this.gridVisibleColumns = this.getGridVisibleColumns();
        });
      });
  }

  private getSliderExpirations(): void {
    this.optionMonitorService
      .getSliderExpirations(this.instrument.stockId, this.instrument.regionId)
      .subscribe(item => {
        this.sliderExps = item.body;
      });
  }

  private getExpirations(tabType: string): void {
    this.spinner.show('optionMonitor');
    const method = tabType === 'instrument' ? 'getExpiration' : 'getFutureExpiration';

    this.optionMonitorService[method](getHttpParams({
      [tabType === 'instrument' ? 'stockId' : 'underlyingId']: this.id,
      futExpDate: this.futExpDate
    } as any))
      .pipe(finalize(() => this.spinner.hide('optionMonitor')))
      .subscribe(expirations => {
        expirations.body.forEach((item) => {
          this.expirations.push({
            id: item.expDate,
            value: item.expDate,
            type: 'expiration',
            typeId: item.type,
            daysToExp: item.daysToExp
          });
        }, this);
        this.getResult(true, true, () => {
          this.gridVisibleColumns = this.getGridVisibleColumns();
        });
      });
  }

  onEditColumnsClick() {
    if (this.isMobile) {
      this.editColumnsPopupPosition = {my: 'center', at: 'center', of: window};
    } else {
      const height = document.getElementsByClassName('service-result')[0].clientHeight;
      if (this.editColumnsPopupHeight < height) {
        this.editColumnsPopupPosition = {my: 'right top', at: 'bottom', of: '#editServiceColumnsButton'};
      } else {
        this.editColumnsPopupPosition = {my: 'right bottom', at: 'top', of: '#editServiceColumnsButton'};
      }
    }
    this.editColumnsPopupVisible = true;
  }

  getSettingTip() {
    const windowWidth = document.getElementsByClassName('service-tabs')[0]?.clientWidth;
    if (windowWidth > 1569) {
      this.settingTip = null;
    } else {
      this.settingTip = 'Column Settings';
    }
  }

  onSubmit() {
    this.getResult(true, true, () => {
      this.gridVisibleColumns = this.getGridVisibleColumns();
    });
  }

  onDownloadCSVClick(event) {
    if (this.selectedExpiration.value === 'All') {
      this.expiration = [];
      const height = document.documentElement.clientHeight - event.clientY;
      if (130 < height) {
        this.downloadSCVPopupPosition = {my: 'right top', at: 'bottom', of: '#downloadService'};
      } else {
        this.downloadSCVPopupPosition = {my: 'right bottom', at: 'top', of: '#downloadService'};
      }
      this.downloadCSVPopupVisible = true;
    } else {
      this.expiration = this.selectedExpiration;
      this.onDownloadClick();
    }
  }

  onPopupCancel() {
    this.downloadCSVPopupVisible = false;
  }

  onDownloadClick() {
    const state = this.store.getState();
    const currentTab = getCurrentTab(state);
    if (currentTab && currentTab.data.serviceTabs) {
      this.expiration = currentTab.data.serviceTabs[0].filters.expirations;
      if (this.expiration.value === 'All') {
        this.expiration = this.expirations;
      }
    }
    this.popupCredit = false;
    this.isError = false;
    this.optionMonitorService.downloadCSVBlob(
      this.currentTab.type === TabTypeEnum.OPTION_CHAIN ? this.instrument.stockId : this.instrument.underlyingId,
      this.instrument.regionId,
      this.expiration ?
        (Array.isArray(this.expiration)) ?
          this.expiration.map(expiration => expiration.value) : ((this.expiration.type === 'expiration') ? this.expiration.id : '')
        : '',
      this.expiration ? (this.expiration.type === 'type') ? this.expiration.id : '' : '',
      this.selectedCenter,
      (this.selectedStrike !== 'All') ? this.selectedStrike : '',
      this.selectedType.value,
      this.gridHeaderTitles,
      this.instrument.symbol,
      this.mode,
      this.currentTab.type,
      this.currentTab.type === TabTypeEnum.FUTURES_OPTION_CHAIN ? this.futExpDate : undefined
    ).subscribe(data => {
      this.downloadFile(data);
    }, error => {
      this.isError = true;
      this.popupCredit = true;
    });
    this.downloadCSVPopupVisible = false;
  }

  downloadFile(data: any) {
    let name = this.instrument.symbol;
    Utils.downloadFile(data, name);
  }

  onColumnSwitch(columns: string[]) {
    this.editColumnsPopupVisible = false;
    this.store.dispatch(TabsActions.updateServiceTabData({
      name: 'visibleColumns',
      value: columns
    }));
    this.getResult(true, true, (me) => {
      me.gridVisibleColumns = me.getGridVisibleColumns();
    });
  }

  saveDefault(columns: string[]) {
    this._updateDefaultConfig(columns.map(x => x));
  }

  getResult(stopPrevious, hasMask?, callback?): void {
    if (hasMask) {
      this.isLoading = true;
      this.spinner.show('optionMonitor');
    }
    if (stopPrevious) {
      this._getListOptionsDataRow(callback);
    }
  }

  strikeSkewExpiration(expiration): void {
    let value = expiration;
    if (expiration && typeof expiration === 'object') {
      value = expiration.value;
    }
    this.chartExpiration = value;
  }

  onExpirationButtonClick(expiration) {
    this.chartExpiration = expiration;
    this.strikeSkewChartVisible = true;
  }

  onStrikeButtonClick(strike) {
    this.chartStrike = strike;
    this.timeSkewChartVisible = true;
  }

  setDefaultConfigClick() {
    try {
      this.store.dispatch(TabsActions.updateServiceTabData({
        name: 'type',
        value: {name: 'Call&Put', value: ''}
      }));
      this.onColumnSwitch(this.defaultColumns.map(x => x));
    } catch (e) {
    }
  }

  getGridVisibleColumns() {
    const visibleColumns = [];
    const gridColumns = this.gridColumns ? Object.keys(this.gridColumns) : [];
    const type = this.selectedType.value;
    this.visibleColumns.forEach(column => {
      if (gridColumns.indexOf(column) > -1) {
        visibleColumns.push(column);
      }
      if (gridColumns.indexOf('call_' + column) > -1 && (type === '' || type === 'CALL')) {
        visibleColumns.push('call_' + column);
      }
      if (gridColumns.indexOf('put_' + column) > -1 && (type === '' || type === 'PUT')) {
        visibleColumns.push('put_' + column);
      }
    });
    return visibleColumns;
  }

  onEODChartsClick() {
    this.chartVisible = true;
  }

  onFutCurveClick() {
    this.chartFutCurveVisible = true;
  }

  onSurfaceClick() {
    this.surfaceVisible = true;
  }

  onRefreshDataClick(event) {
    this.getResult(true, true, () => {
      this.gridVisibleColumns = this.getGridVisibleColumns();
    });
    this.workspaceService.sendRefreshButtonClick(event);
  }

  closeCalculatorWindow() {
    this.calculatorsPopupPopupVisible = false;
    this.optionsCalculator?.clearAll();
    this.probabilityCalculator.clearAll();
    this.futuresCalculator?.clearAll();
    this.optionsCalculator?.ngOnDestroy();
    this.probabilityCalculator.ngOnDestroy();
    this.futuresCalculator?.ngOnDestroy();
    this.selectedInstrument = null;
  }

  onCalculatorButtonClick(): void {
    let stockName = this.instrument.symbol;
    const id = this.tabType === TabTypeEnum.OPTION_CHAIN ? this.instrument.stockId : this.instrument.underlyingId;
    if (this.instrument.exchange) {
      stockName = stockName.concat(':').concat(this.instrument.exchange);
    } else {
      stockName = stockName.concat(':').concat(this.instrument.code);
    }
    this.selectedInstrument = {
      [this.tabType === TabTypeEnum.OPTION_CHAIN ? 'stockId' : 'underlyingId'] : id,
      stockName: stockName,
      value: 'calc'};
    this.calculatorsPopupPopupVisible = true;
  }

  switchModeOptions() {
    this.optionsCalculator.switchMode();
    this.isEODOptions = !this.isEODOptions;
  }

  switchModeProbability() {
    this.probabilityCalculator.switchMode();
    this.isEODProbability = !this.isEODProbability;
  }

  returnRegionOptions($event) {
    this.regionIdOptions = $event.region;
    if (this.regionIdOptions === 2 || this.regionIdOptions === 3 || this.regionIdOptions === 4) {
      this.isEODOptions = true;
    }
  }

  returnRegionProbability($event) {
    this.regionIdProbability = $event.region;
    if (this.regionIdProbability === 2 || this.regionIdProbability === 3 || this.regionIdProbability === 4) {
      this.isEODProbability = true;
    }
  }

  showMessage(event) {
    this.notify(event.message, event.type);
  }

  private filterExpirationByType(filterType: string) {
    const expFilter = this.expirations.filter(value => {
      return value.type === 'expiration';
    });
    switch (filterType) {
      case 'ALL':
        return expFilter;
      case 'NEXT_2':
        return expFilter.filter(value => {
          return value.typeId === 1;
        }).slice(0, 2);
      case 'NEXT_3':
        return expFilter.filter(value => {
          return value.typeId === 1;
        }).slice(0, 3);
      case 'NEXT_4':
        return expFilter.filter(value => {
          return value.typeId === 1;
        }).slice(0, 4);
      case 'WEEKLYS':
        return expFilter.filter(value => {
          return value.typeId === 9;
        });
      case 'QUARTERLYS':
        return expFilter.filter(value => {
          return value.typeId === 8;
        });
      case 'VIX_RULE':
        return expFilter.filter(value => {
          return value.typeId === 7;
        });
      default:
        break;
    }
  }

  private _getListOptionsDataRow(callback?) {
    const filterType = this.selectedExpiration ? (this.selectedExpiration.type === 'type') ? this.selectedExpiration.id : null : null;
    let isSendFilterType = false;
    let expirations: any = [];
    if (filterType) {
      // todo эти 2 лучше обрабатывать на беке
      if (filterType === 'NON_LEAPS' || filterType === 'LEAPS') {
        isSendFilterType = true;
      } else {
        expirations = this.filterExpirationByType(filterType);
      }
    } else {
      if (Array.isArray(this.selectedExpiration)) {
        this.selectedExpiration.forEach(exp => {
          expirations.push(this.expirations.filter(value => {
            return value.id === exp.id;
          })[0]);
        });
      } else {
        expirations.push(this.expirations.filter(value => {
          return value.id === this.selectedExpiration.id;
        })[0]);
      }
    }

    if (!isSendFilterType) {
      const observeRequest: any = {};
      expirations.forEach(value => {
        if (!value?.id) return;
        // TODO: Убрать неявное использование методов
        observeRequest[value.id] = this.optionMonitorService[this.tabType === 'instrument' ? 'getResult' : 'getFuturesResult'](
          getHttpParams({
            [this.tabType === 'instrument' ? 'stockId' : 'underlyingId']: this.id.toString(),
            regionId: this.instrument.regionId.toString(),
            [this.tabType === 'instrument' ? 'expDate' : 'optExpDate']: value.id,
            futExpDate: this.futExpDate,
            filterType: '',
            center: this.selectedCenter.toString(),
            strikesN: (this.selectedStrike !== 'All') ? this.selectedStrike : '',
            type: this.tabType === 'instrument' ? this.selectedType.value : this.selectedType.value.substring(0, 1),
            columns: [...this.visibleColumns, ...this.alwaysVisibleColumns],
            rtMode: this.tabType === 'instrument' ? this.mode.split('_')[0] : undefined
          })
        );
      });
      if (callback) {
        callback(this);
      }
      forkJoin(observeRequest)
        .pipe(finalize(() => {
          this.isLoading = false;
          this.spinner.hide('optionMonitor');
        }))
        .subscribe(responses => {
          if (responses) {
            const result: any[] = [];
            expirations.forEach(value => {
              const res: any = responses[value.id];
              if (res && res.status === 200) {
                if (res.body && res.body.length > 0) {
                  res.body.forEach(resItem => {
                    result.push(resItem);
                  });
                }
              }
            });
            if (result.length > 0) {
              this.result = this.getGroupedData(OptionMonitorComponent.getSortedData(result));
              this.carouselInit();
            }
          }
        });
    } else {
      // TODO: Убрать неявное использование методов
      this.optionMonitorService[this.tabType === 'instrument' ? 'getResult' : 'getFuturesResult'](
        getHttpParams({
          [this.tabType === 'instrument' ? 'stockId' : 'underlyingId']: this.id.toString(),
          regionId: this.instrument.regionId.toString(),
          futExpDate: this.currentTab.data.serviceTabs[0].filters.futExpDate,
          [this.tabType === 'instrument' ? 'expDate' : 'optExpDate']: this.selectedExpiration ?
            (Array.isArray(this.selectedExpiration)) ?
              this.selectedExpiration.map(expiration => expiration.value) : ((this.selectedExpiration.type === 'expiration') ? this.selectedExpiration.id : '')
            : '',
          filterType,
          center: this.selectedCenter.toString(),
          strikesN: (this.selectedStrike !== 'All') ? this.selectedStrike : '',
          type: this.tabType === 'instrument' ? this.selectedType.value : this.selectedType.value.substring(0, 1),
          columns: [...this.visibleColumns, ...this.alwaysVisibleColumns],
          rtMode: this.tabType === 'instrument' ? this.mode.split('_')[0] : undefined
        })
      )
        .pipe(finalize(() => {
          this.isLoading = false;
          this.spinner.hide('optionMonitor');
        }))
        .subscribe(response => {
          if (response.status === 200) {
            const result: any[] = response.body;
            if (result.length > 0) {
              this.result = this.getGroupedData(OptionMonitorComponent.getSortedData(result));
              this.carouselInit();
              if (callback) {
                callback(this);
              }
            }
          }
        });
    }
  }

  private getGroupedData(value: any[]): any[] {
    let expirations = [];
    if (value.length) {
      const groups = {};
      const type = this.selectedType.value === 'PUT' ? 'put' : 'call';
      for (let i = 0; i < value.length; i++) {
        const expiration = value[i].expirationdate || value[i].optexpdate;
        if (!groups[expiration]) {
          expirations.push(expiration);
          groups[expiration] = {};
          groups[expiration].forward = value[i][type + '_forwardprice'];
          groups[expiration].forward_eod = value[i][type + '_forwardprice_eod'];
          groups[expiration].days = value[i][type + '_days' + ((this.isDelayed || this.instrument.regionId !== 1) ? '_eod' : '')];
          groups[expiration].rows = [];
        }
        value[i].type = 'row';
        groups[expiration].rows.push(value[i]);
      }
      value = [];

      expirations = this.sortExpirations(expirations);

      for (let i = 0; i < expirations.length; i++) {
        const daysToExp = this.expirations.find(exp => exp.id === expirations[i]).daysToExp;

        value.push({
          type: 'expiration',
          expiration: expirations[i],
          forward: groups[expirations[i]].forward,
          forward_eod: groups[expirations[i]].forward_eod,
          days: daysToExp ? daysToExp : groups[expirations[i]].days,
          stockid: this.instrument.stockId
        });

        groups[expirations[i]].rows.forEach(item => {
          item.stockid = this.instrument.stockId;
          value.push(item);
        });
      }
      return value;
    } else {
      return [];
    }
  }

  private sortExpirations(expirations) {
    return expirations.sort((a, b) => {
      return new Date(a).getTime() - new Date(b).getTime();
    });
  }

  private _updateServiceTabData(name, value) {
    this.store.dispatch(TabsActions.updateServiceTabData({
      name: name,
      value: value
    }));
  }

  private _updateDefaultConfig(columns: string[]) {
    this.store.dispatch(ColumnsActions.updateColumnsConfig({
      name: this.currentTab.type === TabTypeEnum.OPTION_CHAIN ? 'OptionsMonitor' : 'FuturesOptionMonitor',
      value: columns
    }));
  }

  private notify(text, type) {
    this.commonService.sendNotification(text, type);
  }

  tipeLeft(): void {
    this.offset--;
    this.rightButt = false;
    this.tipe();
  }

  tipeRight(): void {
    this.offset++;
    this.leftButt = false;
    this.tipe();
  }

  private tipe(): void {
    if (this.offset <= 0) this.leftButt = true;
    if (this.offset + this.actTiles.length >= this.tiles.length) this.rightButt = true;
    this.actTiles = [];
    for (let i = 0; i < this.qtt; i++) {
      let index = i + this.offset;
      if (index < 0) index += this.tiles.length;
      if (index >= this.tiles.length) index -= this.tiles.length;
      this.actTiles[i] = this.tiles[index];
    }
  }

  private carouselInit(): void {
    this.qtt = 0;
    let amount = 0;
    this.tiles = [];
    this.actTiles = [];
    this.sliderExps.forEach((item) => {
      amount++;
      const tile = new Tile;
      const typeId = (this.expirations.find(i => i.id === item.expDate)).typeId;
      const type = typeId === 9 ? '(W)' : typeId === 8 ? '(Q)' : '';
      if (item.atmIV === 0) {
        tile.iv = 0;
      } else {
        tile.iv = item.atmIV ? item.atmIV : item.atmIV_eod;
      }
      if (item.atmIVChg === 0) {
        tile.iv_eod = 0;
      } else {
        tile.iv_eod = item.atmIVChg ? item.atmIVChg : item.atmIVChg_eod;
      }
      tile.date = OptionMonitorComponent
        .getMon((item.expDate.split('-'))[1] - 1) + (item.expDate.split('-'))[2] + ' `' + (item.expDate.split('-'))[0].slice(2) + type;
      tile.dateR = item.expDate;
      this.tiles.push(tile);
    });
    this.qtt = Math.floor(this._eref.nativeElement.clientWidth / 88) - 1;
    if (this.qtt > amount) {
      this.qtt = amount;
      this.rightButt = true;
    }
    this.boxWidth = this._eref.nativeElement.clientWidth / this.qtt;
    this.tipe();
  }

  taleClick(date: string): void {
    if (date === 'All') {
      this.filter.viewFromSlider({id: 'ALL', value: 'All', type: 'type'});
    } else {
      const exp = this.expirations.find((i) => i.id === date);
      this.filter.viewFromSlider(exp);
    }
  }

  public getForwardPrice(date: string): string {
    const currrentExpiration = this.result.filter(
      (item) => item.expirationdate === date
    );
    for ( let item of currrentExpiration) {
      return item?.call_forwardprice
    }
  }

  public getForwardPriceEod(date: string): string {
    const currrentExpiration = this.result.filter(
      (item) => item.expirationdate === date
    );
    for ( let item of currrentExpiration) {
      return item?.call_forwardprice_eod
    }
  }

  public setGridHeaderTitles(gridHeader: string[]): void {
    this.gridHeaderTitles = gridHeader;
  }
}
